import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { PRINTERS_FEATURE_KEY } from './keys';
import { printersReducer } from './reducers/printers.reducer';
import { PrintersEffects } from './effects/printers.effects';

export function providePrintersStore(): EnvironmentProviders[] {
    return [provideState(PRINTERS_FEATURE_KEY, printersReducer), provideEffects(PrintersEffects)];
}
